export default async function () {
  const botTokenURL = process.env.REACT_APP_API_URL;

  const res = await fetch(botTokenURL, { method: "Get" });
  const { token } = await res.json();
  localStorage.setItem("BotToken", token);

  return token;
}
